import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import CreateEnvironment from "./environment/CreateEnvironment";
import CreateUser from "./user/CreateUser";
import EnvironmentList from "./environment/EnvironmentList";
import LogList from "./log/LogList";
import UserList from "./user/UserList";
import DomainList from "./domain/DomainList";
import CreateDomain from "./domain/CreateDomain";
import SessionList from "./auditTrail/SessionList";
import SyncSessionList from "./syncLogs/SyncSessionList";
import ProductsList from "./productVersion/ProductsList";
import CreateEnvironmentTemplate from "./environmentTemplate/CreateEnvironmentTemplate";
import EnvironmentTemplateList from "./environmentTemplate/EnvironmentTemplateList";

const ObjectList = ({ onClick = () => { } }) => {
    const { objectType } = useParams();

    const [selectedObject, setSelectedObject] = useState(objectType);
    const [showCreateUserModal, setShowCreateUserModal] = useState(false);
    const [showCreateDomainModal, setShowCreateDomainModal] = useState(false);
    const [showCreateEnvironmentModal, setShowCreateEnvironmentModal] = useState(false);
    const [showCreateEnvironmentTemplateModal, setShowCreateEnvironmentTemplateModal] = useState(false);

    useEffect(() => {
        setSelectedObject(objectType);
    }, [objectType]);

    const renderUserList = useMemo(() => (
        <>
            <CreateUser show={showCreateUserModal} onCancel={() => setShowCreateUserModal(false)} />
            <UserList onClickNew={() => setShowCreateUserModal(true)} onClick={onClick} />
        </>
    ), [showCreateUserModal, setShowCreateUserModal, onClick]);

    const renderEnvironmentList = useMemo(() => (
        <>
            <CreateEnvironment show={showCreateEnvironmentModal} onCancel={() => setShowCreateEnvironmentModal(false)} />
            <EnvironmentList onClickNew={() => setShowCreateEnvironmentModal(true)} onClick={onClick} />
        </>
    ), [showCreateEnvironmentModal, setShowCreateEnvironmentModal, onClick]);

    const renderDomainLogList = useMemo(() => (
        <LogList onClick={onClick} />
    ), [onClick]);

    const renderDomainList = useMemo(() => (
        <>
            <CreateDomain show={showCreateDomainModal} onCancel={() => setShowCreateDomainModal(false)} />
            <DomainList onClickNew={() => setShowCreateDomainModal(true)} onClick={onClick} />
        </>
    ), [showCreateDomainModal, setShowCreateDomainModal, onClick]);

    const renderEnvironmentTemplatesList = useMemo(() => (
        <>
            <CreateEnvironmentTemplate show={showCreateEnvironmentTemplateModal} onCancel={() => setShowCreateEnvironmentTemplateModal(false)} />
            <EnvironmentTemplateList onClickNew={() => setShowCreateEnvironmentTemplateModal(true)} onClick={onClick} />
        </>
    ), [showCreateEnvironmentTemplateModal, setShowCreateEnvironmentTemplateModal, onClick]);

    const objList = useMemo(() => {
        switch (selectedObject) {
            case "user": {
                return renderUserList;
            }
            case "environment": {
                return renderEnvironmentList;
            }
            case "domain-logs": {
                return renderDomainLogList;
            }
            case "domain": {
                return renderDomainList;
            }
            case "environment-templates": {
                return renderEnvironmentTemplatesList;
            }
            case "audit-trail": {
                return <SessionList />
            }
            case "products": {
                return <ProductsList />
            }
            case "support-logs": {
                return <SyncSessionList />
            }
            default: {
                return <></>
            }
        }
    }, [selectedObject, renderUserList, renderEnvironmentList, renderDomainLogList, renderDomainList, renderEnvironmentTemplatesList]);

    return objList;
};

export default ObjectList;
